var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowUpBlueActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163456",
    "data-name": "Group 163456",
    transform: "translate(-1548 -974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140826",
    "data-name": "Rectangle 140826",
    width: 24,
    height: 24,
    transform: "translate(1548 974)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163453",
    "data-name": "Group 163453",
    transform: "translate(214 947)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1336 29)",
    fill: "#d8f2fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163263",
    "data-name": "Group 163263",
    transform: "translate(-52 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more_vert_black_24dp",
    transform: "translate(1386 39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_84083",
    "data-name": "Path 84083",
    d: "M0,9,5,4.5,0,0",
    transform: "translate(1393.5 53.5) rotate(-90)",
    fill: "none",
    stroke: "#4092df",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpBlueActive);
export default __webpack_public_path__ + "static/media/icon-arrow-up-blue-active.9c78a0b8f77d404e35b88932435478e7.svg";
export { ForwardRef as ReactComponent };